import { https, httpsMultipart } from 'shared/utils/https';
import {
  ICreateSectionRequestDTO,
  IEditSectionRequestDTO,
  ISectionListParamsDTO,
  ISectionListResponseDTO,
  ISectionsOrderRequestDTO,
  IStaticPageListResponseDTO,
  IStaticPagePriceGroupDTO,
  IStaticPageResponseDTO,
  IStaticPagesOrderRequestDTO,
} from './static-pages.dto';

const staticPagesEntitiesBaseURL = '/v1';

export const staticPagesData = {
  getSections: async (params: ISectionListParamsDTO): Promise<ISectionListResponseDTO> => {
    const url = `${staticPagesEntitiesBaseURL}/sections`;
    const { data } = await https.get<ISectionListResponseDTO>(url, { params });
    return data;
  },
  createSection: async (body: ICreateSectionRequestDTO): Promise<void> => {
    const url = `${staticPagesEntitiesBaseURL}/sections`;
    const { data } = await https.post(url, body);
    return data;
  },
  editSection: async ({ id, ...rest }: IEditSectionRequestDTO): Promise<void> => {
    const url = `${staticPagesEntitiesBaseURL}/sections/${id}`;
    const { data } = await https.patch(url, rest);
    return data;
  },
  deleteSection: async (id: string): Promise<void> => {
    const url = `${staticPagesEntitiesBaseURL}/sections/${id}`;
    const { data } = await https.delete(url);
    return data;
  },
  sortSections: async (body: ISectionsOrderRequestDTO): Promise<void> => {
    const url = `${staticPagesEntitiesBaseURL}/sections/arrange`;
    await https.post(url, body);
  },
  getStaticPageList: async (id: string): Promise<IStaticPageListResponseDTO> => {
    const url = `${staticPagesEntitiesBaseURL}/sections/${id}/pages`;
    const { data } = await https.get<IStaticPageListResponseDTO>(url);
    return data;
  },
  getStaticPageDetail: async (sectionId: string, staticPageId: string): Promise<IStaticPageResponseDTO> => {
    const url = `${staticPagesEntitiesBaseURL}/sections/${sectionId}/pages/${staticPageId}`;
    const { data } = await https.get<IStaticPageResponseDTO>(url);
    return data;
  },
  createStaticPage: async (body: FormData, sectionId: string): Promise<void> => {
    const url = `${staticPagesEntitiesBaseURL}/sections/${sectionId}/pages`;
    const { data } = await httpsMultipart.post(url, body);
    return data;
  },
  editStaticPage: async (body: FormData, sectionId: string, staticPageId: string): Promise<void> => {
    const url = `${staticPagesEntitiesBaseURL}/sections/${sectionId}/pages/${staticPageId}`;
    const { data } = await httpsMultipart.patch(url, body);
    return data;
  },
  deleteStaticPage: async (sectionId: string, staticPageId: string): Promise<void> => {
    const url = `${staticPagesEntitiesBaseURL}/sections/${sectionId}/pages/${staticPageId}`;
    const { data } = await https.delete(url);
    return data;
  },
  sortStaticPages: async (body: IStaticPagesOrderRequestDTO, sectionId: string): Promise<void> => {
    const url = `${staticPagesEntitiesBaseURL}/sections/${sectionId}/pages/arrange`;
    await https.post(url, body);
  },
  getGroupList: async (): Promise<IStaticPagePriceGroupDTO> => {
    const url = `${staticPagesEntitiesBaseURL}/price-groups`;
    const { data } = await https.get<IStaticPagePriceGroupDTO>(url);
    return data;
  },
};
